import React from "react";
import { convertTimestamp } from "../../utils/timeConverter";
import { CiUser } from "react-icons/ci";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type CommentEditProps = {
  userFeed: any;
  handleCloseEdit: () => void;
  pImage?: string;
  handleUpdateComment: (e: any) => void;
  loading: boolean;
  editedComment: any;
  setEditedComment: React.Dispatch<React.SetStateAction<string | undefined>>;
};
const CommentEdit: React.FC<CommentEditProps> = ({
  pImage,
  handleUpdateComment,
  userFeed,
  handleCloseEdit,
  loading,
  editedComment,
  setEditedComment,
}) => {
  const [onChange, setOnChange] = React.useState(false);

  const handleOnChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const inputValue = e.target.value.trim();
    setEditedComment(e.target.value);
    if (inputValue.trim().length > 0) {
      setOnChange(true);
    } else {
      setOnChange(false);
    }
  };
  return (
    <div className="fixed inset-0 w-full z-30 align-middle flex justify-center items-center transition-colors overflow-y-hidden bg-black/20">
      <div className="bg-[#FFF] lg:w-[80%] lg:h-[283px] h-[270px] w-[85%] shadow rounded-lg p-8 font-Rubik flex flex-col lg:gap-5">
        <div className="flex w-[70%] lg:gap-4 gap-2 h-8 items-center lg:text-base">
          <div className="lg:w-8 lg:h-8 w-6 h-6">
            {pImage ? (
              <img
                src={ipfsGatewayImage(pImage!)}
                alt=""
                className="lg:w-8 lg:h-8 w-6 h-6 rounded-full"
              />
            ) : (
              <div className="lg:w-8 lg:h-8 w-6 h-6  bg-slate-100 flex items-center justify-center rounded-full">
                <CiUser size={15} />
              </div>
            )}
          </div>
          <div className=" text-[#01262F] text-xs font-medium">
            {`${userFeed?.creator.firstName} ${userFeed?.creator.lastName}`}
          </div>
          <div className=" text-[#646464] text-[10px] font-normal">
            {convertTimestamp(userFeed?.createdAt)}
          </div>
        </div>
        <form
          className="w-full flex flex-col gap-5"
          onSubmit={handleUpdateComment}
        >
          <textarea
            value={editedComment}
            onChange={handleOnChange}
            rows={4}
            className="border border-solid text-pretty border-midGreen j rounded-md px-5 py-3 font-Rubik overflow-auto overscroll-auto resize-none text-sm font-normal outline-none w-full block break-words text-justify text-[#646464]"
          />
          <div className="flex gap-4 w-[50%]">
            <button
              type="submit"
              className={`bg-midGreen capitalize flex justify-center items-center lg:h-12 h-7 rounded shadow w-[104px] text-white text-xs lg:text-base font-Rubik ${onChange ? 'cursor-pointer' : 'cursor-not-allowed'}`}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </button>
            <div
              className="flex bg-midGreen text-white cursor-pointer justify-center items-center lg:h-12 h-7 w-[104px] rounded shadow text-sm lg:text-base font-Rubik"
              onClick={handleCloseEdit}
            >
              Cancel
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CommentEdit;
